$(function () {

  // sortable
  var $sortable;
  function initSortable() {
    $sortable = $('#images-sortable');
    $sortable.sortable({
      axis: 'y',
      handle: '.label',
      update: function () {
        $sortable.find('.sortable-image').each(function (index) {
          $(this).find('.position').val(index);
        });
      }
    });
    $sortable.sortable('refresh');
  };
  initSortable();

  function toggleEmptyMessage() {
    if ($('#images-sortable').find('.sortable-image:not(.empty)').length) {
      $('#images-sortable').find('.empty').hide();
    } else {
      $('#images-sortable').find('.empty').show();
    }
  };
  toggleEmptyMessage();

  function buildImageSortable($images) {
    initSortable();

    $images.each(function () {
      var $this = $(this);

      if ($sortable.find('.sortable-image[data-id=' + $this.data('id') + ']').length > 0) {
        return true; //don't append since we already have this image
      }

      $sortable.append($('<div class="sortable-image" data-id="' + $this.data('id') + '">' +
                         '<div class="label"><span class="handle">&#9776;</span><img src="' + $this.attr('src') + '" /></div>' + 
                         '<input type="hidden" name="image_group_images_image_id[]" value="' + $this.data('id') + '" />' + 
                         '<input type="hidden" name="image_group_images_' + $this.data('id') + '_position" class="position" value="" />' + 
                         '<button data-id="' + $this.data('id') + '" class="remove-image pull-right btn btn-secondary btn-sm">' + I18n.t('remove') + '</button></div>'))
    });
    
    $sortable.sortable('refresh');
    toggleEmptyMessage();
  };

  window._insertImages = function (images) {
    var $images = $(images);
    buildImageSortable($images);
  };

  $(document.body).on('click', '.remove-image', function () {
    $sortable.find('.sortable-image[data-id=' + $(this).data('id') + ']').remove();
    toggleEmptyMessage();
    return false;
  });

});